// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
        emergentLink: 'home-emergent-link',
        header: 'home-header',
        logo: 'home-logo',
        navApparel: 'nav-apparel',
        navAbout: 'nav-about',
        navPrograms: 'nav-programs',
        navCreed: 'nav-creed',
        navMore: 'nav-more',
        navMoreDropdown: 'nav-more-dropdown',
        heroVideo: 'hero-video',
        heroHeadline: 'hero-headline',
        heroCta: 'hero-cta',
        manifesto: 'section-manifesto',
        apparel: 'section-apparel',
        programs: 'section-programs',
        creed: 'section-creed',
        marquee: 'section-marquee',
        footer: 'site-footer',
        newsletterInput: 'newsletter-email-input',
        newsletterSubmit: 'newsletter-submit',
        programCard: 'program-card',
        enrollmentForm: 'enrollment-form',
        enrollmentName: 'enrollment-name-input',
        enrollmentEmail: 'enrollment-email-input',
        enrollmentGoal: 'enrollment-goal-input',
        enrollmentSubmit: 'enrollment-submit',
};
